module.exports = __webpack_public_path__ + "img/Union 71.35e41ae4.svg";